/* Generic announcement popup. Reads config from data-* attributes on the
 * <dialog> element. Once-per-visitor enforced via localStorage; an optional
 * expire-days setting re-shows after N days from the dismissal timestamp. */

(function () {
  if (window.__hh_popup_loaded) return;
  window.__hh_popup_loaded = true;

  function shouldShow(key, expireDays) {
    if (!key) return true;
    try {
      var stored = localStorage.getItem(key);
      if (!stored) return true;
      if (expireDays > 0) {
        var ts = parseInt(stored, 10);
        if (isNaN(ts)) return true;
        var ageMs = Date.now() - ts;
        return ageMs > expireDays * 86400000;
      }
      return false;
    } catch (e) {
      // localStorage blocked (private mode, etc.) — fail open: show every time
      return true;
    }
  }

  function markSeen(key) {
    if (!key) return;
    try { localStorage.setItem(key, String(Date.now())); } catch (e) { /* ignore */ }
  }

  function open(dialog) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function close(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function init(dialog) {
    var key = dialog.getAttribute('data-storage-key');
    var expireDays = parseInt(dialog.getAttribute('data-expire-days'), 10) || 0;
    var delay = parseInt(dialog.getAttribute('data-delay-ms'), 10) || 0;
    var dismissBackdrop = dialog.getAttribute('data-dismiss-backdrop') !== 'false';

    var dismissed = false;
    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      markSeen(key);
    }

    if (!shouldShow(key, expireDays)) return;

    setTimeout(function () { open(dialog); }, delay);

    // Anything inside the dialog with data-popup-close (the × button, plus
    // a CTA button when no URL is configured) dismisses and closes.
    var closers = dialog.querySelectorAll('.hh-popup__close, [data-popup-close]');
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function () {
        dismiss();
        close(dialog);
      });
    });

    if (dismissBackdrop) {
      // Clicks on the ::backdrop pseudo-element bubble up to the <dialog>
      // element with e.target === dialog. Clicks on content children bubble
      // through with e.target === that child.
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) {
          dismiss();
          close(dialog);
        }
      });
    }

    // ESC key fires `cancel` on <dialog>; native close also fires `close`.
    dialog.addEventListener('cancel', dismiss);
    dialog.addEventListener('close', dismiss);
  }

  function boot() {
    var dialogs = document.querySelectorAll('dialog[data-section-type="hh-popup"]');
    Array.prototype.forEach.call(dialogs, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
